module.exports = __webpack_public_path__ + "static/media/attachment.a04125a9.png";